/**
 * Analytics Provider Interface
 * 
 * This defines the contract for any analytics provider.
 * Implement this interface to swap providers (PostHog, Mixpanel, Amplitude, etc.)
 */

export class AnalyticsProvider {
  /**
   * Initialize the analytics provider
   * @param {Object} config - Provider-specific configuration
   */
  init(config) {
    throw new Error('init() must be implemented');
  }

  /**
   * Identify a user
   * @param {string} userId - Unique user identifier
   * @param {Object} properties - User properties (email, name, etc.)
   */
  identify(userId, properties = {}) {
    throw new Error('identify() must be implemented');
  }

  /**
   * Reset/logout the current user
   */
  reset() {
    throw new Error('reset() must be implemented');
  }

  /**
   * Track an event
   * @param {string} eventName - Name of the event
   * @param {Object} properties - Event properties
   */
  track(eventName, properties = {}) {
    throw new Error('track() must be implemented');
  }

  /**
   * Track a page view
   * @param {string} pageName - Name of the page
   * @param {Object} properties - Page properties
   */
  page(pageName, properties = {}) {
    throw new Error('page() must be implemented');
  }

  /**
   * Set user properties without tracking an event
   * @param {Object} properties - Properties to set
   */
  setUserProperties(properties) {
    throw new Error('setUserProperties() must be implemented');
  }

  /**
   * Check if provider is enabled
   * @returns {boolean}
   */
  isEnabled() {
    return true;
  }
}
